<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">社区公告</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="goFabu">新建公告</Button>
      </div>
    </div>
    <Card v-if="isJiedao" style="margin: 0 20px 20px 20px;">
      <div class="select_box" v-if="isJiedao">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
                <i-col span="8">
                    <select-community ref="community" @communityChange="communityChange"></select-community>
                </i-col>
          </row>
        </i-form>
        <!-- <Select v-model="community" style="width:410px" @on-change="change">
          <Option v-for="item in communityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select> -->
      </div>
    </Card>
    <div class="btn-wrapper box" style="padding-left: 20px;">
      <div class="btn" :class="tapidnex == '3'?'active':''" @click="tabclick(3)">已发布</div>
      <div class="btn" :class="tapidnex == '0'?'active':''" @click="tabclick(0)">草稿</div>
    </div>
    <div class="content" v-if="org == 'single'">
      <Card :bordered="false" :class="[showList.length?'':'card-wrapper']">
        <div slot="title">
          <p style="font-size: 20px;color: #4b4b4b;font-weight: normal">公告公示</p>
          <p
            style="font-size: 16px;color: #999;font-weight: normal;margin-top: 10px"
          >公告公示之后可从民生通首页图片展示处进行查看，最多可在此处展示5个，其余在历史公告处查看</p>
        </div>
        <div class="card-con box" v-for="(item, index) in showList" :key="index">
          <div class="box g-img">
            <img :src="item.pic" alt />
          </div>
          <div class="box_f1 g-context">
            <p class="g-title">{{item.title}}</p>
            <p class="g-time">
              <span>{{item.time}}</span>
              <span style="margin-left: 20px">
                <i class="iconfont icon-chakan" style="margin-right: 5px"></i>
                <span>{{item.preNum}}</span>
              </span>
            </p>
          </div>
          <div class="popupState">{{item.popUpState==1?'已设为弹屏':''}}</div>
          <div class="caozuo box_f1 box" style="align-items:center; display: -webkit-flex;">
            <span @click="goDetail(index)">编辑</span>
            <span @click="cancel(item.id)">撤回</span>
            <span v-if="index != 0" @click="sortJian(index)">上移</span>
            <span v-if="index != 4" @click="sortJia(index)">下移</span>
          </div>
        </div>
        <Spin fix v-if="loading"></Spin>
      </Card>

      <div class="btn-wrapper box">
        <div class="btn" :class="status == '2'?'active':''" @click="tabChange(2)">公告历史</div>
        <div class="btn" :class="status == '0'?'active':''" @click="tabChange(0)">草稿</div>
      </div>

      <div>
        <Table border :columns="columns1" :data="ggData" :loading="isTableLoading"></Table>
        <div class="page">
          <page :current="pageNum" :total="total" @on-change="pageChange" :page-size="5" show-total />
        </div>
      </div>
    </div>
    <div class="content" v-if="org == 'all'">
      <div>
        <Table border :columns="columns2" :data="allGgData" :loading="isTableLoading"></Table>
        <div class="page">
          <page :current="pageNum" :total="total" @on-change="pageChange" :page-size="10" show-total />
        </div>
      </div>
    </div>
    <Modal v-model="modal1" title="删除公告" @on-ok="delNotice">
      <p>确定删除吗？删除后将无法恢复</p>
    </Modal>
  </div>
</template>

<script>
var that;
import selectCommunity from '../../../components/selectCommunity'
export default {
   components: {
      selectCommunity
    },
  data() {
    return {
      tapidnex:3,
      columns1: [
        {
          title: "标题",
          key: "title"
        },
        {
          title: "时间",
          key: "time"
        },
        {
          title: "查看数",
          key: "preNum"
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  on: {
                    click: () => {
                      that.editNotice(params.index);
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      //   that.showDelVote(params.index);
                      console.log(params);

                      that.cancel(that.ggData[params.index].id);
                    }
                  }
                },
                "[撤回]"
              )
            ]);
          }
        }
      ],
      ggData: [],
      isTableLoading: false,
      pageNum: 1,
      pageSize: 5,
      status: 2, //0 草稿  2历史
      showList: [],
      loading: false,
      total: 0,
      modal1: false,
      delIndex: "",
      allGgData: [],
      columns2: [
        {
          title: "标题",
          key: "title"
        },
        {
          title: "行政区域",
          key: "communityName"
        },
        {
          title: "时间",
          key: "time"
        },
        {
          title: "查看数",
          key: "preNum"
        },
        {
          title: "状态",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: params.row.status==1?"#ff7b44":"#5e6d94"
                  },

                },
                 params.row.status == 0? '草稿' : params.row.status == 1?'已公示':'已发布'
              ),
            ])
          }
        },
        {
          title: "是否弹屏",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: params.row.popUpState==1?"#ff7b44":"#5e6d94"
                  },

                },
                 params.row.popUpState == 1? '是' :'否'
              ),
            ])
          }
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  on: {
                    click: () => {
                      console.log(params)
                      //   that.toNewVote(params.index);
                      that.editNotice(params.index);
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      //   that.showDelVote(params.index);
                      console.log(params);
                      that.showDelModel(params.index);
                    }
                  }
                },
                "[删除]"
              )
            ]);
          }
        }
      ],
      communityList: [],
      community: parseInt(this.$store.state.streetorcommunityid),
      org: 'single'
    };
  },
  computed: {
    isJiedao() {
      console.log(this.$store.state.isJiedao);
      return parseInt(this.$store.state.isJiedao);
    }
  },
  methods: {
    tabclick(index){
      console.log(index)
      this.tapidnex=index
      this.status = index;
      this.pageNum = 1;
      this.getNoticeAll1();
    },
    goFabu() {
      this.$router.push({
        name: "newGonggao"
      });
    },
    getNotice() {
      this.isTableLoading = true;
      var community = this.community
      var index = String(community).indexOf(',')
      var idlist = index == -1 ? [community] : community.split(',')
      var url = this.urlobj.getNoticeList;
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.status,
        communityIdList: idlist
        // id: item.id
      };
      this.$post(url, data).then(res => {
        this.total = res.total;
        var list = res.rows.map(item => {
          return {
            title: item.title,
            preNum: item.previewNumber,
            time: item.noticeTime
              ? item.noticeTime.substr(0, item.noticeTime.length - 2)
              : "",
            id: item.id
          };
        });
        this.ggData = list;
        this.isTableLoading = false;
      });
    },
    getShowNotice() {
      this.loading = true;
      var community = this.community
      var index = String(community).indexOf(',')
      var idlist = index == -1 ? [community] : community.split(',')
      var url = this.urlobj.getNoticeList;
      var data = {
        pageNum: 1,
        pageSize: 5,
        status: 1,
        communityIdList: idlist
      };
      this.$post(url, data).then(res => {
        var list = res.rows.map(item => {
          return {
            pic: item.coverPicUrl,
            title: item.title,
            time: item.noticeTime
              ? item.noticeTime.substr(0, item.noticeTime.length - 2)
              : "",
            preNum: item.previewNumber,
            id: item.id,
            popUpState:item.popUpState
          };
        });
        this.showList = list;
        this.loading = false;
      });
    },
    pageChange(val) {
      this.pageNum = val;
      var community = this.community
      var index = String(community).indexOf(',')
      var idlist = index == -1 ? [community] : community.split(',')
      //if(idlist.length == 1) {
      if(this.org == 'single') {
        this.getNotice()
      }else {
        this.getNoticeAll()
      }
    },
    sortJia(index) {
      var idList = this.showList.map(item => {
        return item.id;
      });
      var id1 = idList[index];
      var id2 = idList[index + 1];
      var id = "";
      id = id1;
      idList[index] = idList[index + 1];
      idList[index + 1] = id;
      var url = this.urlobj.noticeSort;
      var data = {
        idList
      };
      this.$post(url, idList).then(res => {
        if (res.isSucceed) {
          this.$Message.success("操作成功");
          this.getShowNotice();
        }
      });
    },
    sortJian(index) {
      var idList = this.showList.map(item => {
        return item.id;
      });
      var id1 = idList[index];
      var id2 = idList[index - 1];
      var id = "";
      id = id1;
      idList[index] = idList[index - 1];
      idList[index - 1] = id;
      var url = this.urlobj.noticeSort;
      var data = {
        idList
      };
      this.$post(url, idList).then(res => {
        if (res.isSucceed) {
          this.$Message.success("操作成功");
          this.getShowNotice();
        }
      });
    },
    goDetail(index) {
      var id = this.showList[index].id;
      this.$router.push({ name: "newGonggao", query: { id } });
    },
    editNotice(index) {
      var id = this.org=='all'?this.allGgData[index].id:this.ggData[index].id;
      this.$router.push({ name: "newGonggao", query: { id } });
    },
    cancel(id) {
      var url = this.urlobj.cancelNotice;
      var data = {
        id,
        status: 0
      };
      this.$post(url, data).then(res => {
        if (res.isSucceed) {
          this.$Message.success("操作成功");
          this.getNotice();
          this.getShowNotice();
        }
      });
    },
    delNotice() {
      var id = this.org=='all' ? this.allGgData[this.delIndex].id:this.ggData[this.delIndex].id;
      this.isTableLoading = true
      this.$delete(this.urlobj.delNotice(id)).then(res => {
        this.isTableLoading = false
        if (res.isSucceed) {
          this.pageNum = 1;
          this.$Message.success("删除成功");
          if(this.org=='all'){
            this.getNoticeAll()
          }else{
            this.getNotice();
          }

        }
      }).catch(e=>{
        console.log(e)
        this.isTableLoading = false
      });
    },
    showDelModel(index) {
      this.delIndex = index;
      this.modal1 = true;
    },
    tabChange(val) {
      console.log(val);
      this.status = val;
      this.pageNum = 1;
      this.getNotice();
    },
    getCommunity() {
      var url = this.urlobj.getChildShequ;
      this.$get(url).then(res => {
        var ids = res.rows.map(item => {
          return item.communityId;
        });
        ids = ids.join(",");
        var item = {
          name: "全部",
          id: ids
        };
        var list = res.rows.map(item => {
          return {
            name: item.communityName,
            id: item.communityId
          };
        });
        list.unshift(item);
        console.log(list);
        this.communityList = list;
        //this.community = parseInt(this.$store.state.streetorcommunityid);
        this.community = ids
        console.log(this.communityList);
        console.log(this.community)
        this.org = 'all';
        this.getNoticeAll();
      });
    },
    getNoticeAll() {
      this.isTableLoading = true;
      var community = this.community
      console.log(this.community)
      var index = String(community).indexOf(',')
      var idlist = index == -1 ? [community] : community.split(',')
      var url = this.urlobj.getNoticeList;
      var data = {
        pageNum: this.pageNum,
        pageSize: 10,
        status: 3,
        communityIdList: idlist
        // id: item.id
      };
      this.$post(url, data).then(res => {
        this.total = res.total;
        var list = res.rows.map(item => {
          return {
            ...item,
            title: item.title,
            preNum: item.previewNumber,
            time: item.noticeTime
              ? item.noticeTime.substr(0, item.noticeTime.length - 2)
              : "",
            id: item.id,
            communityName: item.communityName
          };
        });
        this.allGgData = list;
        this.isTableLoading = false;
      });
    },
    getNoticeAll1() {
      this.isTableLoading = true;
      var community = this.community
      console.log(this.community)
      var index = String(community).indexOf(',')
      var idlist = index == -1 ? [community] : community.split(',')
      var url = this.urlobj.getNoticeList;
      var data = {
        pageNum: this.pageNum,
        pageSize: 10,
        status: this.status,
        communityIdList: idlist
        // id: item.id
      };
      this.$post(url, data).then(res => {
        this.total = res.total;
        var list = res.rows.map(item => {
          return {
            ...item,
            title: item.title,
            preNum: item.previewNumber,
            time: item.noticeTime
              ? item.noticeTime.substr(0, item.noticeTime.length - 2)
              : "",
            id: item.id,
            communityName: item.communityName
          };
        });
        this.allGgData = list;
        this.isTableLoading = false;
      });
    },
    communityChange(value){
      console.log('=========父组件=========')
      console.log(value)
        if(value){
          this.community = value.communityId
          // let community = []
          // community.push(value.communityId)

          //this.community = community.concat(value.childrenIdList).join(',')
        }else{
          this.community = this.$store.state.streetorcommunityid
        }
        this.pageNum = 1
        this.getNoticeAll()
        this.org = 'all'

      },
    change(val) {
      var community = val
      var index = String(community).indexOf(',')
      var idlist = index == -1 ? [community] : community.split(',')
      this.pageNum = 1
      console.log(idlist)
      if(idlist.length == 1) {
        this.getNotice();
        this.getShowNotice();
        this.org = 'single'
      } else {
        this.getNoticeAll()
        this.org = 'all'
      }
    }
  },
  mounted() {
    if (parseInt(this.$store.state.isJiedao)) {
      this.org = 'all'
      this.getNoticeAll();
      //this.getCommunity();
    }else{
      this.org = 'single'
      this.getNotice();
      this.getShowNotice();
    }


  },
  created() {
    that = this;
  }
};
</script>

<style lang="less" scoped>
  .toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
  .toptableft{display: flex;display: -webkit-flex;padding-left: 20px;}
  .toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
  .toptableft span:nth-child(4){width: 136px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
  .activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
  .nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.card-wrapper /deep/ .ivu-card-head {
  border-bottom: none;
}
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
  /deep/ .ivu-table-wrapper {
    border: none;
  }
  /deep/ th .ivu-table-cell {
    font-weight: 600;
  }
  /deep/ .ivu-table:after {
    display: none;
  }
  /deep/ .ivu-table:before {
    display: none;
  }
  /deep/ .ivu-table th {
    background-color: #f3f4f5;
  }
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   max-width: 96%;
  margin: 20px;
  margin-top: 0;
  //   margin-left: 40px;
  overflow: hidden;
  //   overflow-y: scroll;
  // background: #fff;
  // padding: 0 15px 0 15px;
}
/deep/ .ivu-card-body {
  padding: 0 0 16px 16px;
}
.card-con {
  border-bottom: 1px solid #ddd;
  padding: 20px;
  align-items: center
}
.popupState{
    width: 100px;
    color: #ff7b44;
}
.g-img {
  width: 202px;
  height: 102px;
  border-radius: 5px;
  img {
    width: 202px;
    height: 102px;
  }
}
.g-context {
  padding: 10px 20px;
}
.g-time {
  margin-top: 40px;
  font-size: 14px;
  color: #999;
}
.g-title {
  font-size: 18px;
  color: #333;
}
.caozuo span {
  padding: 0 16px;
  border: 1px solid #dedede;
  border-radius: 5px;
  margin-right: 20px;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.btn-wrapper {
  margin: 20px 0;
  .btn {
    height: 30px;
    line-height: 30px;
    /*width: 50px;*/
    padding: 0 10px;
    text-align: center;
    background: #fff;
    color: #999;
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .active {
    background: #ff7b44;
    color: #fff;
  }
}
.select_box{
  margin-top: 16px;
}

/deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

</style>
